import React, { useEffect, useRef, useState } from 'react';
import { Form, Radio, Space } from 'antd';
import type { RadioChangeEvent } from 'antd';
import '../SurveyAnswer.less';

// 逻辑切换 - 清除关联题目逻辑id集合
let delIds: string[] = [];

// 判断题
const Judge = ({ body, id, required, optionList, num, questionLogicsEntity, setDataList, dataList, dataListRef, initForm }: { body?: string; required?: boolean; optionList?: Array<string>; num?: number; id?: number; questionLogicsEntity: any; setDataList: any; dataList?: []; dataListRef?: []; initForm?: any }) => {
    const [value, setValue] = useState();
    const [count, setCount] = useState(0);
    const currentData = useRef<any>([]);
    const onChange = (e: RadioChangeEvent) => {
        setValue(e.target.value);
    };

    // 判断当前选项是否存在跳转逻辑1
    const getCurrentOption = (logicsEntity: any, value?: number) => {
        let arr = logicsEntity.filter((item: any) => item.optionId === value);
        if (arr && arr.length) {
            return arr[0];
        }
        return null;
    };

    // 回显
    useEffect(() => {
        if (optionList && optionList.length) {
            if (initForm) {
                const val = initForm[`${id}-3`];
                if (val) {
                    let valRes: any = Number(val);
                    setValue(valRes);
                    setCount(Math.random() * 10000);
                }
            } else {
                let answer;
                let selectArr: any[] = optionList.filter((it: any) => it.selected);
                answer = selectArr && selectArr.length ? selectArr[0].id : '';
                setValue(answer);
            }
        }
    }, [optionList, initForm]);

    // 深度遍历 - 嵌套逻辑子级 - 清除隐藏题目关联逻辑
    const dealChildrenLogic = (optionTarget: any, list: any[]) => {
        if (optionTarget.targetQuestionId) {
            let startIndex!: number, endIndex!: number;
            list.forEach((item: any, index: number) => {
                if (optionTarget.sourceQuestionId === item.id) {
                    startIndex = index;
                }
                if (optionTarget.targetQuestionId === item.id) {
                    endIndex = index;
                }
            });
            list.forEach((item: any, i: number) => {
                if (i > startIndex && i < endIndex) {
                    if (!delIds.includes(`topicId-${item.id}`)) {
                        delIds.push(`topicId-${item.id}`);
                    }
                    if (item.questionLogicsEntity) {
                        dealChildrenLogic(item.questionLogicsEntity[0], list);
                    }
                } else if (!endIndex && i > startIndex) {
                    // if (!delIds.includes(`topicId-${item.id}`)) {
                    //     delIds.push(`topicId-${item.id}`);
                    // }
                }
            });
        } else {
            delIds = [];
        }
    };

    // 逻辑切换 - 清除隐藏题目关联逻辑
    const dealLogic = (list: any[]) => {
        const current = value;
        if (current) {
            const topicId = id;
            if (value) {
                const optionId = value;
                const curItem: any = list.filter((item: any) => item.id === topicId) || [];
                if (curItem.length && curItem[0].id === topicId && curItem[0].questionLogicsEntity) {
                    let optionTarget = getCurrentOption(curItem[0].questionLogicsEntity, Number(optionId));
                    if (optionTarget) {
                        // 获取当前逻辑选中题目的end下标
                        let currentEndIndex!: number;
                        list.forEach((item: any, index: number) => {
                            if (optionTarget.targetQuestionId === item.id) {
                                currentEndIndex = index;
                            }
                        });

                        dealChildrenLogic(optionTarget, list);
                        console.log(delIds);

                        const resDelIds = delIds.filter((delId: string) => {
                            const curIndex = list.findIndex((it: any) => delId === `topicId-${it.id}`);
                            if (currentEndIndex) {
                                return curIndex <= currentEndIndex;
                            } else {
                                return curIndex;
                            }
                        });

                        // 跳转到结束
                        let resultList: any = [];
                        resultList = list.map((item: any, i: number) => {
                            let newItem = { ...item };
                            let keys: any = Object.keys(newItem);
                            let isShowTopic: any = keys.filter((it: any) => it.includes('topicId'));
                            let isShowTopicTarget: any = keys.filter((it: any) => it.includes('isShow'));
                            let isDel = isShowTopic.filter((it: string) => resDelIds.includes(it));
                            let isShow = isShowTopicTarget.filter((it: string) => {
                                const showId = `topicId-${it.split('-')[1]}`;
                                return it && resDelIds.includes(showId);
                            });
                            console.log(isDel, isShow);
                            if ((isDel && isDel.length) || (isShow && isShow.length)) {
                                delete newItem[isDel[0]];
                                delete newItem[isShow[0]];
                            }
                            return newItem;
                        });
                        return resultList;
                    }
                    return list;
                }
                return list;
            }
            return list;
        }
        return list;
    };

    // 监听 - 选项逻辑跳转
    useEffect(() => {
        if (questionLogicsEntity && dataList && dataList.length && dataListRef && value) {
            let initList: any = [...dataList];
            console.log(dataList);
            initList = dataList.map((item: any, i: number) => {
                let newItem = { ...item };
                let keys: any = Object.keys(item);
                let isShowTopic: any = keys.filter((it: any) => it.includes('topicId') || it.includes('isShow'));
                if (isShowTopic && isShowTopic.length) {
                    delete newItem[`topicId-${id}`];
                    delete newItem[`isShow-${id}`];
                }
                return newItem;
            });
            // setDataList([...resultList]);

            let optionTarget = getCurrentOption(questionLogicsEntity, value);
            if (optionTarget) {
                // 跳转到结束
                if (optionTarget.targetQuestionId === -1) {
                    let startIndex!: number;
                    initList.forEach((item: any, index: number) => {
                        if (optionTarget.sourceQuestionId === item.id) {
                            startIndex = index;
                        }
                    });
                    let resultList: any = [];
                    resultList = initList.map((item: any, i: number) => {
                        let newItem = { ...item };
                        if (i > startIndex) {
                            newItem[`topicId-${id}`] = true;
                        }
                        return newItem;
                    });
                    if (localStorage.getItem('currentChangeTopic') === String(id)) {
                        setDataList([...resultList]);
                    } else {
                        delIds = [];
                        const resList = dealLogic(resultList);
                        setDataList([...resList]);
                    }

                    // 跳转下一题
                } else {
                    let startIndex!: number, endIndex!: number;
                    initList.forEach((item: any, index: number) => {
                        if (optionTarget.sourceQuestionId === item.id) {
                            startIndex = index;
                        }
                        if (optionTarget.targetQuestionId === item.id) {
                            endIndex = index;
                        }
                    });
                    let resultList: any = [];
                    resultList = initList.map((item: any, i: number) => {
                        let newItem = { ...item };
                        if (i > startIndex && i < endIndex) {
                            newItem[`topicId-${id}`] = true;
                        }
                        if (i === endIndex) {
                            newItem[`isShow-${id}`] = true;
                        }

                        return newItem;
                    });
                    console.log(initList);
                    if (localStorage.getItem('currentChangeTopic') === String(id)) {
                        setDataList([...resultList]);
                    } else {
                        delIds = [];
                        const resList = dealLogic(resultList);
                        setDataList([...resList]);
                    }
                }
            } else {
                delIds = [];
                const resList = dealLogic(initList);
                setDataList([...resList]);
            }
        }
    }, [questionLogicsEntity, value, dataListRef]);

    return (
        <>
            <Form.Item name={`${id}-3`} rules={[{ required, message: '该题为必答题，请作答后提交。' }]} label={<div style={{ display: 'flex' }} dangerouslySetInnerHTML={{ __html: `<span class="title-num">${num}.</span>` + `<span>${body}</span>` }}></div>}>
                <Radio.Group style={{ width: '100%' }} onChange={onChange} value={value}>
                    <Space direction="vertical" style={{ width: '100%' }}>
                        {/* <Radio value={'对'}>对</Radio>
                        <Radio value={'错'}>错</Radio> */}
                        {optionList && optionList.length
                            ? optionList.map((option: any, index) => (
                                  <Radio value={option.id} key={index}>
                                      {option.content}
                                  </Radio>
                              ))
                            : null}
                    </Space>
                </Radio.Group>
            </Form.Item>
        </>
    );
};

export default Judge;
